import React from "react";
import { z } from "zod";
export interface Form {
  name: string;
  slug: string;
  controls: Record<string, FormControl>;
  schemas: Record<string, z.ZodObject<any>>;
}
export type InputGroupType = {
  name: string;
  options: string[];
};

export type OptionWithNote<T> = {
  opt: T;
  note: string;
};

export type FormControlType =
  | "intro"
  | "text"
  | "url"
  | "email"
  | "textarea"
  | "phone"
  | "checkbox"
  | "checkbox-group"
  | "checkbox-with-note"
  | "radio"
  | "file"
  | "accept";

export type FileOptions = {
  maxFileSizeMB: number;
  allowedFileExtentions: string[];
};

export enum TextLengthCheckOptionType {
  WORD_COUNT = "word_count",
  CHAR_COUNT = "char_count",
}

export type TextFormOptions = {
  lengthCheckType: TextLengthCheckOptionType;
};

export type FormControlOptions =
  | string[]
  | TextFormOptions
  | FileOptions
  | InputGroupType[]
  | OptionWithNote<string>[];

export interface FormControl {
  label: string;
  type: FormControlType;
  /** Plain text; supports **bold** and [label](https://...) links. */
  notes?: string[];
  /** "spaced" separates each note, for option-by-option descriptions. */
  notesLayout?: "spaced";
  /** Shown under the question as "Example: ..." and used as the placeholder. */
  example?: string;
  isOptional?: boolean;
  maxLength?: number;
  minLength?: number;
  options?: FormControlOptions;
}

export interface IntroFormControl extends FormControl {
  type: "intro";
}

export interface TextFormControl extends FormControl {
  type: "text" | "textarea";
  options: TextFormOptions;
}

export interface FileFormControl extends FormControl {
  type: "file";
  options: FileOptions;
}

export interface CheckboxFormControl extends FormControl {
  type: "checkbox";
  options: string[];
}

export interface CheckboxGroupFormControl extends FormControl {
  type: "checkbox-group";
  options: InputGroupType[];
}

export interface CheckboxWithNoteFormControl<T extends string>
  extends FormControl {
  type: "checkbox-with-note";
  options: OptionWithNote<T>[];
}

export interface RadioFormControl extends FormControl {
  type: "radio";
  options: string[];
}

export interface AcceptTermsFormControl extends FormControl {
  type: "accept";
  termsAndconditions?: string;
}

export enum FormResponseStatus {
  NOT_SUBMITTED = "NOT_SUBMITTED",
  IN_REVIEW = "IN_REVIEW",
  ACCEPTED = "ACCEPTED",
  REJECTED = "REJECTED",
  CONFIRMED = "CONFIRMED",
  ONBOARDED = "ONBOARDED",
}

export interface FormResponse {
  documentName: string;
  uid: string;
  userFirstName: string;
  userLastName: string;
  userEmail: string;
  userPhone: string;
  [key: string]: any;
}
